<ng-container *transloco="let t">
  <core-dialog
    (closeDialogEvent)="closeModal(false)"
    (saveDialogEvent)="onSave()"
    [saveIsDisabled]="createOrEditDialog && userForm.invalid"
    [dialogTitle]="userDialogTitle"
    [dialogSubtitle]="userDialogSubtitle"
    [confirmButtonText]="userDialogConfirmButtonText"
    [closeButtonText]="userDialogCancelButtonText"
  >
    @if (createOrEditDialog) {
      <div>
        <form [formGroup]="userForm">
          <div class="form-control space-y-4">
            <label class="floating-label flex flex-col">
              <span>{{ t('edit-user-dialog-form-first-name') }}</span>
              <input
                [attr.aria-invalid]="
                  userFormFirstName?.invalid && userFormFirstName?.touched
                    ? true
                    : null
                "
                [required]="true"
                class="input placeholder-neutral w-full grow"
                formControlName="userFormFirstName"
                [ngClass]="{
                  'input-error':
                    userFormFirstName?.invalid && userFormFirstName?.touched,
                }"
                placeholder="{{ t('edit-user-dialog-form-first-name') }}"
                type="text"
              />
              @if (userFormFirstName?.invalid && userFormFirstName?.touched) {
                @if (
                  userFormFirstName?.errors?.['minlength'] ||
                  userFormFirstName?.errors?.['maxlength']
                ) {
                  <p class="text-error text-sm">
                    {{
                      t('edit-user-dialog-error-first-name-minMaxLength', {
                        minLength: 2,
                        maxLength: 64,
                      })
                    }}
                  </p>
                }
              }
            </label>
            <label class="floating-label flex flex-col">
              <span>{{ t('edit-user-dialog-form-last-name') }}</span>
              <input
                [attr.aria-invalid]="
                  userFormLastName?.invalid && userFormLastName?.touched
                    ? true
                    : null
                "
                class="input placeholder-neutral w-full grow"
                formControlName="userFormLastName"
                placeholder="{{ t('edit-user-dialog-form-last-name') }}"
                type="text"
              />
            </label>
            <label class="floating-label flex flex-col">
              <span>{{ t('edit-user-dialog-form-company-name') }}</span>
              <input
                [attr.aria-invalid]="
                  userFormCompanyName?.invalid && userFormCompanyName?.touched
                    ? true
                    : null
                "
                [required]="true"
                class="input placeholder-neutral w-full grow"
                formControlName="userFormCompanyName"
                [ngClass]="{
                  'input-error':
                    userFormCompanyName?.invalid &&
                    userFormCompanyName?.touched,
                }"
                placeholder="{{ t('edit-user-dialog-form-company-name') }}"
                type="text"
              />
            </label>
            <label class="floating-label flex flex-col">
              <span>{{ t('edit-user-dialog-form-business-unit') }}</span>
              <input
                class="input placeholder-neutral w-full grow"
                formControlName="userFormBusinessUnit"
                placeholder="{{ t('edit-user-dialog-form-business-unit') }}"
                type="text"
              />
            </label>
            <label class="floating-label flex flex-col">
              <span>{{ t('edit-user-dialog-form-email') }}</span>
              <input
                [attr.aria-invalid]="
                  userFormEmail?.invalid && userFormEmail?.touched ? true : null
                "
                [required]="true"
                class="input placeholder-neutral w-full grow"
                formControlName="userFormEmail"
                [ngClass]="{
                  'input-error':
                    userFormEmail?.invalid && userFormEmail?.touched,
                }"
                placeholder="{{ t('edit-user-dialog-form-email') }}"
                type="text"
              />
              @if (userFormEmail?.invalid && userFormEmail?.touched) {
                @if (userFormEmail?.errors?.['email']) {
                  <p class="text-error text-sm">
                    {{ t('edit-profile-error-email-format') }}
                  </p>
                }
              }
            </label>
            <label class="flex flex-col items-center">
              <div class="floating-label flex w-full">
                <span>{{ t('edit-user-dialog-form-password') }}</span>
                <input
                  class="input placeholder-neutral w-full grow"
                  [attr.aria-invalid]="
                    userFormPassword?.invalid && userFormPassword?.touched
                      ? true
                      : null
                  "
                  [type]="getInputType()"
                  formControlName="userFormPassword"
                  placeholder="{{ t('edit-user-dialog-form-password') }}"
                  autocomplete="on"
                />
                <button
                  type="button"
                  class="btn btn-square btn-ghost absolute right-0"
                  (click)="toggleShowPassword()"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="h-6 w-6"
                  >
                    @if (showPassword) {
                      <ng-container>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
                        />
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
                        />
                      </ng-container>
                    } @else {
                      <ng-template *ngTemplateOutlet="EyeIcon"></ng-template>
                    }
                    <ng-template #EyeIcon>
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
                      />
                    </ng-template>
                  </svg>
                </button>
              </div>
            </label>
            <button
              type="button"
              class="btn btn-neutral right-0"
              (click)="generatePassword()"
            >
              {{ t('edit-user-dialog-generate-password') }}
            </button>
          </div>
        </form>
      </div>
    }
  </core-dialog>
</ng-container>
